<template>
  <vs-popup
    :title="getTitle()"
    @onClose="handleOnClose"
    :active.sync="showThisPopup"
    class="reject-guest-popup"
  >
    <div v-if="booking">
      <vs-row>
    <p :class="`mb-1 ${booking && arrivedCount == booking.guestCount ? 'w-full text-center text-xl' : '' }` " style="font-weight:600">
        {{getArrivedCountTitle}}
      </p>
      </vs-row>
  
      <vs-row vs-w="12" class="mt-4" vs-justify="center" v-if=" booking.guestCount && arrivedCount == booking.guestCount && !viewArrivals && !isEditingArrival">
      <vs-button
        class="mr-2"
        @click="showArrivals"
        >
        View arrivals
        </vs-button>

    </vs-row>
      <div v-if="booking && arrivedCount != booking.guestCount || isEditingArrival" >
        <p class="mb-1 mt-2 text-sm text-gray-500">
       {{isEditingArrival ? 'Edit guests arrived' : 'New guests arrived'}} 
      </p>

      <vs-input
          class="inputx"
          v-model="numberOfArrivedGuest"
          type="number"
          
          @change="() => {if(isEditingArrival && numberOfArrivedGuest > guestsLeft + editingArrival.numPeopleArrived ){
                          numberOfArrivedGuest = guestsLeft + editingArrival.numPeopleArrived 
                          }            
                          if(numberOfArrivedGuest > guestsLeft && !isEditingArrival) {
                          numberOfArrivedGuest = guestsLeft
                            } else if (numberOfArrivedGuest<0){
                            numberOfArrivedGuest = 0
                            } 
                          }"
        />

  <p class="mb-1 mt-2 text-sm text-gray-500">
       {{isEditingArrival ? 'Edit note' : 'Note'}} 
      </p>
              <textarea
        v-model="note"
        type="text"
        class="
          mb-2
          rounded-lg
          w-full
          h-16
          focus:outline-none
          border border-gray-200
          focus:ring focus:border-blue-300
          p-2
        "
      >
      </textarea>
      </div>
    </div>
    

    <vs-row vs-w="12" vs-justify="flex-end" v-if=" booking &&  arrivedCount != booking.guestCount || isEditingArrival">
      <vs-button
        class="mr-2"
        color="success"
        :disabled="!validForm"
        @click="handleSaveClick"
        >{{isEditingArrival ? "Update" : "Add arrival"}}</vs-button
      >
      <vs-button type="border" color="primary" @click="handleOnClose"
        >Cancel</vs-button
      >
    </vs-row>

      <div v-if="viewArrivals || booking && arrivedCount != booking.guestCount " >
        <p class="mb-1 mt-2 text-lg text-gray-500">
       Arrivals
      </p>
      <vs-row v-for="(arrival, index) in booking.arrivals" :key="index" class="flex gap-2 mt-2">
           <vs-button type="border" class="text-xs py-1" @click="editArrival(arrival)"
        >Edit</vs-button
      >
          <p>{{getArrivalTime(arrival.registrationTime)}}: Guests: {{arrival.numPeopleArrived}}, Note: {{arrival.note}}</p>
  
      </vs-row>
   <vs-button type="border" color="primary" class="mt-2" style="float:right" v-if="arrivedCount == booking.guestCount" @click="handleOnClose"
        >Cancel</vs-button
      >
    </div>
    

  </vs-popup>
</template>

<script>
import moment from 'moment'
export default {
  
  components: {},
  data() {
    return {
      numberOfArrivedGuest: 0,
      note: "",
      booking: null,
      showThisPopup: false,
      viewArrivals: false,
      isEditingArrival: false,
      editingArrival: null
    };
  },
  mounted() {
    this.viewArrivals = false
   
  },
  computed: {
    validForm() {
      return this.numberOfArrivedGuest > 0 || this.isEditingArrival;
    },

    arrivedCount(){
      if(this.booking){
      if(this.booking.arrivals.length == 0) {return 0}
      var arrived = 0
      this.booking.arrivals.forEach(arrival => {
          arrived += arrival.numPeopleArrived
      });
      return arrived
     
      }
      
    },

    getArrivedCountTitle(){
      if(this.booking){
    if(this.isEditingArrival){return `Editning arival at ${ this.getArrivalTime(this.editingArrival.registrationTime)}`}
     return this.arrivedCount == this.booking.guestCount ? "All guests has arrived" :
                            `${this.arrivedCount} / ${this.booking.guestCount} guests currently arrived`
          
      }
    },

    guestsLeft(){
      if(this.booking){  
        return this.booking.guestCount - this.arrivedCount
      }
    },

  },
  methods: {
    show(booking) {
      this.booking = booking;
      this.showThisPopup = true;
      this.isEditingArrival = false
      this.editingArrival = null
    },
    getTitle() {
      return 'Partial arrival';
    },

    
    handleSaveClick() {
      
      let arrival = {note: this.note, numberOfGuests: this.numberOfArrivedGuest}
      if(this.editingArrival){
       arrival = {note: this.note, numberOfGuests: this.numberOfArrivedGuest, arrivalId: this.editingArrival.registrationId}
      }
      this.$emit('update-guest-arrival-count', { booking: this.booking, arrival: arrival});
      this.handleOnClose();
    },
    handleOnClose() {
      this.numberOfArrivedGuest=0
      this.note = '';
      this.isEditingArrival = false
      this.editingArrival = null
      this.showThisPopup = false;
      this.viewArrivals = false
    },
    showArrivals(){
    this.viewArrivals = true
  },
    editArrival(arrival){
      this.viewArrivals = false
      this.isEditingArrival = true
      this.editingArrival = arrival
      this.note = arrival.note
      this.numberOfArrivedGuest = arrival.numPeopleArrived
    },

    getArrivalTime(time){
        return moment(time).format("HH:mm")
    }

  },
  
};
</script>

<style lang="scss" scoped>
.reject-guest-popup::v-deep {
  z-index: 54000;
  .vs-popup {
    width: 768px;
  }
}
</style>
